<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body" [formGroup]="formGroup">
        <div class="row">
          <div class="col-lg-4 form-group">
            <label for="client">{{ "COMPANY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'client'"
              id="client"
              bindLabel="name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              class="{{ fieldHasErrors('client') ? 'is-invalid' : '' }}"
              [items]="customers"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.client.errors?.required">{{ "ERRORS.FIELD_COMPANY" | translate }}</div>
          </div>
          <div class="col-lg-4 col-12 form-group">
            <label for="label">{{ "LABEL" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="label" class="form-control {{ fieldHasErrors('label') ? 'is-invalid' : '' }}" formControlName="label" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.label.errors?.required">{{ "ERRORS.INSERT_LABEL" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.label?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.label?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="col-lg-4 col-12 form-group" *ngIf="formGroup.value.external">
            <label for="label">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select [items]="nationsWithCodes" bindLabel="name" bindValue="code" [clearable]="false" formControlName="country" [ngClass]="fieldHasErrors('country') ? 'is-invalid' : ''"></ng-select>
          </div>
          <div class="col-lg-4 form-group" *ngIf="!this.formGroup.value.external">
            <div class="d-flex justify-content-between align-items-center" [ngbTooltip]="'KM_EXPLICATION_CALCULATE' | translate">
              <label for="km">{{ "ADDRESS_DISTANCE" | translate }}</label>
              <i class="mb-025" [data-feather]="'info'" size="14"></i>
            </div>
            <input type="number" id="km" placeholder="100" class="form-control {{ fieldHasErrors('km') ? 'is-invalid' : '' }}" formControlName="km" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.km.errors?.required">
              {{ "ERRORS.INSERT_KM" | translate }}
            </div>
          </div>
          <div class="col-12 form-group">
            <label for="street">{{ "STREET" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="street" class="form-control {{ fieldHasErrors('street') ? 'is-invalid' : '' }}" formControlName="street" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.street?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.street?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="col-lg-4 form-group" *ngIf="!this.formGroup.value.external">
            <label for="zipcode">{{ "ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="zipcode" class="form-control {{ fieldHasErrors('zipcode') ? 'is-invalid' : '' }}" formControlName="zipcode" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.zipcode.errors?.required">{{ "ERRORS.INSERT_ZIPCODE" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 4 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="col-lg-4 form-group" *ngIf="!this.formGroup.value.external">
            <label for="city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'city'"
              id="city"
              bindLabel="nice_name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              placeholder="{{ 'ERRORS.SELECT_CITY' | translate }}"
              [items]="_citiesService.list"
              [openOnEnter]="false"
              [virtualScroll]="true"
              (change)="setAutoProvince()"
            >
            </ng-select>
          </div>
          <div class="col-lg-12 form-group" *ngIf="this.formGroup.value.external">
            <label for="city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
            <input formControlName="external_city" id="external_city" class="form-control" [ngClass]="fieldHasErrors('external_city') ? 'is-invalid' : ''" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.external_city.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
          </div>
          <div class="col-lg-4 form-group" *ngIf="!this.formGroup.value.external">
            <label for="province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'province'"
              id="province"
              bindLabel="nice_name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              class="{{ fieldHasErrors('city') ? 'is-invalid' : '' }}"
              placeholder="{{ 'ERRORS.SELECT_CITY' | translate }}"
              [items]="_citiesService.list"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.city.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
          </div>
          <div class="form-group col-12 d-flex align-items-center">
            <small class="mr-1">{{ "EXTERNAL_SITE_QUESTION" | translate }}</small>
            <div class="custom-control custom-control-primary custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch10" formControlName="external" (change)="manageExternalSite()" />
              <label class="custom-control-label" for="customSwitch10"> </label>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <button class="btn btn-primary text-primary" (click)="edit()" *ngIf="_authenticationService.hasCapability('edit_customer_address')">{{ "EDIT" | translate }}</button>
      </div>
    </div>
  </div>
</div>
